import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { hotTopics } from '@/mocks/gossip';

export default function HotRankSection() {
  return (
    <section id="hot" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
        <SectionHeading
          eyebrow="今日热榜"
          title="大家在聊什么，一眼看完"
          desc="热度按讨论量、转发量与打卡评论综合计算，每两小时更新一次排序。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          查看完整热榜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <ol className="lg:col-span-2 space-y-3">
          {hotTopics.slice(0, 6).map((topic) => (
            <li key={topic.id}>
              <Link
                to={`/topic/${topic.id}`}
                className="group flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-colors"
              >
                <span
                  className={`shrink-0 w-9 h-9 flex items-center justify-center rounded-md font-heading text-lg ${
                    topic.hot <= 3
                      ? 'bg-accent-500 text-foreground-950'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {topic.hot}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {topic.title}
                  </span>
                  <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{topic.category}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      热度 {topic.heat}
                    </span>
                  </span>
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </Link>
            </li>
          ))}
        </ol>

        <aside className="rounded-lg bg-secondary-100 border border-secondary-200 p-5 md:p-6 flex flex-col">
          <h3 className="font-heading text-xl text-secondary-900 flex items-center gap-2">
            <i className="ri-calendar-check-line"></i>
            本周互动日程
          </h3>
          <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
            三个玩法每天轮换开奖，打卡与投票全天开放，转发抽奖在每晚 20:00 集中开奖。
          </p>
          <ul className="mt-5 space-y-4">
            {[
              { time: '09:00', label: '今日话题更新', icon: 'ri-sun-line' },
              { time: '14:00', label: '粉丝投票开放', icon: 'ri-bar-chart-2-line' },
              { time: '20:00', label: '转发抽奖开奖', icon: 'ri-gift-2-line' },
            ].map((row) => (
              <li key={row.time} className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-secondary-700">
                  <i className={row.icon}></i>
                </span>
                <span>
                  <span className="block text-sm text-foreground-900">{row.label}</span>
                  <span className="block text-xs text-foreground-500">{row.time}</span>
                </span>
              </li>
            ))}
          </ul>
          <Link
            to="/activities"
            className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm text-secondary-900 hover:text-primary-600 whitespace-nowrap"
          >
            去互动玩法页
            <i className="ri-arrow-right-line"></i>
          </Link>
        </aside>
      </div>
    </section>
  );
}